import Modal from "react-bootstrap/Modal";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  TONES,
  sevenToneScale,
  eightToneScale,
  sixToneScale,
  fiveToneScale,
  otherToneScales,
} from "../../helpers/pianoHelpers";
import { setBaseNote, setDefaultMt, setPianoLabels } from "../../store/actions";
import { putLabelsOnPiano } from "../../helpers/pianoHelpers";
// import { node } from "prop-types";
class PopupMusicTheory extends Component {
  state = {
    modesOfScales: "",
    TONES: TONES,
    sevenToneScale: sevenToneScale,
    eightToneScale: eightToneScale,
    sixToneScale: sixToneScale,
    fiveToneScale: fiveToneScale,
    otherToneScales: otherToneScales,
    note: "C",
    // this.props.tonesMT: this.props.tonesMT,
  };

  componentWillMount() {
    let selectedNotes = this.props.tonesMT;
    if (selectedNotes.tones === 0) {
      // pentatonic
      this.setState({ modesOfScales: "fiveToneScale" });
    } else if (selectedNotes.tones === 1) {
      // 6 tones
      this.setState({ modesOfScales: "sixToneScale" });
    } else if (selectedNotes.tones === 2) {
      // 7 tones
      this.setState({ modesOfScales: "sevenToneScale" });
    } else if (selectedNotes.tones === 3) {
      // 8 tones
      this.setState({ modesOfScales: "eightToneScale" });
    } else if (selectedNotes.tones === 4) {
      // other tones
      this.setState({ modesOfScales: "otherToneScales" });
    }
  }

  // const OCTAVES = [2, 3, 4, 5, 6];

  submitTones = (event) => {
    event.preventDefault();
    if (this.props.enableMusicTheory) {
      let data = {};
      let baseNote = this.state.note;
      let indexBaseNote = this.props.NOTES.findIndex((x) => x === baseNote);
      data.baseNote = indexBaseNote;

      let tones = document.getElementById("tones").value;
      let indexTones = this.state.TONES.findIndex((x) => x === tones);
      data.tones = indexTones;
      console.log(tones);

      let modesOfS = document.getElementById("modesOfScales").value;
      // modesOfS = modesOfS.trim();
      let indexModeOfScale = this.state[
        `${this.state.modesOfScales}`
      ].findIndex((x) => {
        let valueToCompare = !x.secondDegree
          ? `${x.name} ${x.degree || ""} ${x.name2 ? x.name2 : ""}`
          : `${x.name} ${x.degree || ""} ${x.name2 ? x.name2 : ""} ${
              x.secondDegree
            }`;

        return valueToCompare === modesOfS;
      });

      data.modesOfScales = indexModeOfScale;
      data.modesOfScalesValues =
        this.state[`${this.state.modesOfScales}`][indexModeOfScale];
      if (indexTones === 1 || indexTones === 2 || indexTones === 3) {
        document
          .querySelectorAll(".ReactPiano__NoteLabelContainer")
          .forEach((x) => {
            x.classList.remove("hide-labels");
          });
          
        putLabelsOnPiano(
          baseNote,
          this.props.setPianoLabels,
          indexTones,
          data.modesOfScalesValues.y,
          this.props.setBaseNote
        );
      } else {
        // document
        //   .querySelectorAll(".ReactPiano__NoteLabelContainer")
        //   .forEach((x) => {
        //     x.classList.add("hide-labels");
        //   });
      }
      this.props.setMusicTheoryOnPiano(data);
      //   document
      //     .querySelectorAll(".ReactPiano__NoteLabelContainer")
      //     .forEach((x) => {
      //       x.classList.remove("hide-labels");
      //     });
      //   putLabelsOnPiano(
      //     baseNote,
      //     tones,
      //     this.props.setPianoLabels,
      //     indexTones,
      //     data.modesOfScalesValues.y,
      //     this.props.setBaseNote
      //   );

      // this.props.setMusicTheoryOnPiano(data);
    } else {
      //remove old dots
      document
        .querySelectorAll(".react-piano-music-dots")
        .forEach((element) => {
          element.classList.remove("blue");
          element.classList.remove("red");
        });
      //remove numbers
      document
        .querySelectorAll(".react-piano-music-dots span")
        .forEach((element) => (element.innerHTML = ""));
      this.props.setMusicTheoryOnPiano();
    }
    this.props.toggleModal();
  };

  toneChanged = () => {
    let tones = document.getElementById("tones").value;
    if (tones === "Tonal Scales and Modes") {
      // 7 tones
      this.setState({ modesOfScales: "sevenToneScale" });
    } else if (tones === "Pentatonic Scale") {
      // pentatonic
      this.setState({ modesOfScales: "fiveToneScale" });
    } else if (tones === "Hexaphonic Scales") {
      // 6 tones
      this.setState({ modesOfScales: "sixToneScale" });
    } else if (tones === "Octophonic Scales") {
      // 8 tones
      this.setState({ modesOfScales: "eightToneScale" });
    } else if (tones === "Other Scales") {
      // other tones
      this.setState({ modesOfScales: "otherToneScales" });
    }
  };
  render() {
    let allScaleObj = {
      sevenToneScale: this.state.sevenToneScale,
      fiveToneScale: this.state.fiveToneScale,
      sixToneScale: this.state.sixToneScale,
      eightToneScale: this.state.eightToneScale,
      otherToneScales: this.state.otherToneScales,
    };
    return (
      <div>
        <Modal
          size="lg"
          show={this.props.show}
          onHide={() => this.props.toggleModal()}
          aria-labelledby="vocal-range-popup"
        >
          <Modal.Header closeButton>
            <Modal.Title id="vocal-range-popup">Music Theory</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-6">
                  <label className="form-label noselect" htmlFor="mic-switch">
                    Enable Music Theory
                  </label>
                </div>
                <div className="col-6 settings-group">
                  <input
                    className="settings settings-light"
                    id="mic-switch"
                    type="checkbox"
                    checked={this.props.enableMusicTheory}
                    onChange={(event) => {
                      this.props.setEnableMusicTheory(event.target.checked);
                    }}
                  />
                  <label className="settings-btn" htmlFor="mic-switch"></label>
                </div>
              </div>

              {this.props.enableMusicTheory && (
                <div>
                  <div className="row">
                    <div className="form-group col-12">
                      <label className="form-label" htmlFor="baseNote">
                        Root
                      </label>
                      <select
                        id="baseNote"
                        onChange={(e) =>
                          this.setState({ note: e.target.value })
                        }
                        className="form-control form-control-lg"
                        defaultValue={
                          !this.props.tonesMT.baseNote
                            ? this.props.NOTES[0]
                            : this.props.NOTES[this.props.tonesMT.baseNote]
                        }
                      >
                        {this.props.NOTES.map((item) => {
                          return (
                            <option value={item} key={item}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-12">
                      <label className="form-label" htmlFor="tones">
                        Scale
                      </label>
                      <select
                        id="tones"
                        className="form-control form-control-lg"
                        onChange={(event) => this.toneChanged(event)}
                        defaultValue={
                          !this.props.tonesMT.tones
                            ? this.state.TONES[2]
                            : this.state.TONES[this.props.tonesMT.tones]
                        }
                      >
                        {this.state.TONES.map((item) => {
                          return (
                            <option value={item} key={item}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-12 mb-2">
                      <label className="form-label" htmlFor="modesOfScales">
                        Mode
                      </label>
                      <select
                        id="modesOfScales"
                        className="form-control form-control-lg"
                        defaultValue={() => {
                          const selectedMode =
                            allScaleObj[this.state.modesOfScales][
                              this.props.tonesMT.modesOfScales
                            ] || allScaleObj[this.state.modesOfScales][0];

                          return `${selectedMode.name} ${
                            selectedMode.degree || ""
                          }`;
                        }}
                      >
                        {allScaleObj[this.state.modesOfScales].map(
                          (item, index) => (
                            <React.Fragment
                              key={`${item.name}${item.x}${item.y}`}
                            >
                              {/* Additional non-selectable categories based on 'y' */}
                              {this.state.modesOfScales ===
                                "sevenToneScale" && (
                                <>
                                  {item.y === 0 && item.x === 0 && (
                                    <optgroup label="Major Melodic"></optgroup>
                                  )}
                                  {item.y === 1 && item.x === 0 && (
                                    <optgroup label="Major Harmonic"></optgroup>
                                  )}
                                  {item.y === 2 && item.x === 0 && (
                                    <optgroup label="Minor Harmonic"></optgroup>
                                  )}
                                  {item.y === 3 && item.x === 0 && (
                                    <optgroup label="Minor Melodic"></optgroup>
                                  )}
                                </>
                              )}

                              {/* Regular options based on item values */}
                              <option
                                value={
                                  !item.secondDegree
                                    ? `${item.name} ${item.degree || ""} ${
                                        item.name2 ? item.name2 : ""
                                      }`
                                    : `${item.name} ${item.degree || ""} ${
                                        item.name2 ? item.name2 : ""
                                      } ${item.secondDegree}`
                                }
                              >
                                {!item.secondDegree
                                  ? `${item.name} ${item.degree || ""} ${
                                      item.name2 ? item.name2 : ""
                                    }`
                                  : `${item.name} ${item.degree || ""} ${
                                      item.name2 ? item.name2 : ""
                                    } ${item.secondDegree}`}
                              </option>
                            </React.Fragment>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              <button
                className="btn btn_primary btn-lg"
                onClick={(event) => this.submitTones(event)}
              >
                Apply Changes
              </button>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    tonesMT: state.tonesMT,
    NOTES: state.notes,
  };
};
const mapDispatchToProps = {
  setPianoLabels,
  setBaseNote,
  setDefaultMt,
};

export default connect(mapStateToProps, mapDispatchToProps)(PopupMusicTheory);
// export default PopupMusicTheory;
